var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerSuccess24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alerts/banner-success-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 24C5.87258 24 0.5 18.6274 0.5 12C0.5 5.37258 5.87258 0 12.5 0C19.1274 0 24.5 5.37258 24.5 12C24.5 18.6274 19.1274 24 12.5 24ZM11.7919 17.3527L18.2763 8.0893C18.6669 7.53128 18.5312 6.76226 17.9732 6.37165C17.4152 5.98103 16.6462 6.11674 16.2555 6.67476L10.6257 14.7174L8.37505 12.326C7.90821 11.83 7.12766 11.8064 6.63165 12.2732C6.13564 12.74 6.11198 13.5206 6.57882 14.0166L9.86857 17.5119C10.3005 17.9709 11.0011 18.0254 11.4963 17.6612C11.5817 17.6087 11.6666 17.5255 11.7544 17.4057C11.7674 17.3883 11.7799 17.3706 11.7919 17.3527Z",
    fill: "#008638"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerSuccess24);
export default __webpack_public_path__ + "static/media/banner-success-24.2ffd4fc50d9e4e9295ce92b104b51f29.svg";
export { ForwardRef as ReactComponent };